import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { ConfiguratorMode, HandlesMode, initialState } from './reducer';
import {
  makeSelectPaintColorHandles,
  makeSelectPaintMaterialHandles,
  makeSelectPaintTypeHandles,
} from '../HandlesPanel/selectors';
import {
  DrawerHandleType,
  MINIMUM_LARGE_DOORS_HEIGHT,
} from '../../lib/modelBuilder/constants';
import { makeSelectLastHistoryCabinet } from '../Configurator/selectors/history';
import {
  makeSelectCabinet,
  makeSelectFurniture,
} from '../Configurator/selectors/furniture';
import furniture from '../Configurator/sagas/furniture';

/**
 * Direct selector to the modeBar state domain
 */

const selectModeBarDomain = (state: ApplicationRootState) =>
  state.modeBar || initialState;

export const makeSelectConfiguratorMode = () =>
  createSelector(
    selectModeBarDomain,
    (substate): ConfiguratorMode => substate.activeMode,
  );

export const makeSelectIsPaintMode = () =>
  createSelector(
    selectModeBarDomain,
    substate => substate.activeMode === ConfiguratorMode.paint,
  );

export const makeSelectIsSelectorMode = () =>
  createSelector(
    selectModeBarDomain,
    substate => substate.activeMode === ConfiguratorMode.selector,
  );

export const makeSelectIsHandlesMode = () =>
  createSelector(
    selectModeBarDomain,
    substate => substate.activeMode === ConfiguratorMode.handles,
  );

export const makeSelectPaintHandlesMode = () =>
  createSelector(selectModeBarDomain, substate => substate.handlesMode);

export const makeSelectIsDeleteMode = () =>
  createSelector(
    selectModeBarDomain,
    substate => substate.activeMode === ConfiguratorMode.delete,
  );

export const makeSelectShouldShowDrawersHandles = () =>
  createSelector(
    makeSelectFurniture(),
    makeSelectCabinet(),
    (furniture, cabinet): boolean => {
      if (furniture) {
        if (cabinet) {
          return !!cabinet.shelves.find(e => e.drawers.length > 0);
        } else {
          for (const cabinetEntry of furniture.cabinets) {
            if (cabinetEntry.cabinet.shelves.find(e => e.drawers.length > 0))
              return true;
          }
        }
      }

      return false;
    },
  );

export const makeSelectShouldShowDoorsHandles = () =>
  createSelector(
    makeSelectFurniture(),
    makeSelectCabinet(),
    (furniture, cabinet): boolean => {
      if (furniture) {
        if (cabinet) {
          return !!cabinet.shelves.find(
            e => e.doors.length > 0 && e.height < MINIMUM_LARGE_DOORS_HEIGHT,
          );
        } else {
          for (const cabinetEntry of furniture.cabinets) {
            if (
              cabinetEntry.cabinet.shelves.find(
                e =>
                  e.doors.length > 0 && e.height < MINIMUM_LARGE_DOORS_HEIGHT,
              )
            )
              return true;
          }
        }
      }

      return false;
    },
  );

export const makeSelectShouldShowBigDoorsHandles = () =>
  createSelector(
    makeSelectFurniture(),
    makeSelectCabinet(),
    (furniture, cabinet): boolean => {
      if (furniture) {
        if (cabinet) {
          return !!cabinet.shelves.find(
            e => e.doors.length > 0 && e.height >= MINIMUM_LARGE_DOORS_HEIGHT,
          );
        } else {
          for (const cabinetEntry of furniture.cabinets) {
            if (
              cabinetEntry.cabinet.shelves.find(
                e =>
                  e.doors.length > 0 && e.height >= MINIMUM_LARGE_DOORS_HEIGHT,
              )
            )
              return true;
          }
        }
      }

      return false;
    },
  );

export const makeSelectShouldForceChoiceHandles = () =>
  createSelector(
    selectModeBarDomain,
    makeSelectPaintColorHandles(),
    makeSelectPaintTypeHandles(),
    makeSelectPaintMaterialHandles(),
    (substate, color, type, material) => {
      return !material && !type && !color;

      // if (substate.activeMode === ConfiguratorMode.handles) {
      //   if (substate.handlesMode === HandlesMode.doors && !color) return true;
      //   if (
      //     substate.handlesMode === HandlesMode.bigShelves &&
      //     (!material || !type)
      //   )
      //     return true;
      //   if (
      //     substate.handlesMode === HandlesMode.drawers &&
      //     (!type ||
      //       !Object.values(DrawerHandleType).includes(type as DrawerHandleType))
      //   )
      //     return true;
      // }
      // return false;
    },
  );
